// extracted by mini-css-extract-plugin
export default {"main":"AboutSec_main__8dyiF","imgCol":"AboutSec_imgCol__YpUZ0","contentCol":"AboutSec_contentCol__jCZYb"};